// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { minQtyStyles } from "@guestsupply/App/Widgets/ProductDetails/ProductDetailsMinQty";
import { css } from "styled-components";


minQtyStyles.minOrderQty = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                margin-top: 16px;
                align-items: center;
            `,
        },
        heading: {
            weight: "bold",
            size: 14,
            css: css`
                line-height: 16px;
            `,
        },
        text: {
            weight: 400,
            size: 14,
            css: css`
                line-height: 21px;
            `,
        },
    }),
};